import * as React from "react";
import { useEffect } from "react";
import styled from "@mui/material/styles/styled";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { PageMargin } from "../layoutConsts";
import { MainButton } from "fe-common/ui/buttons/mainButton";
import { useRouteHelper } from "../useRouteHelper";
import { AgentRoute } from "../util/agentRoutes";
import { useScreenSize } from "../util/useScreenSize";
import { useDiagnosticNavigation } from "../useDiagnosticNavigation";
import { PatientFirstSummaryContent } from "./patientFirstSummaryContent";
import { ReactComponent as PatientFirstLogo } from "../../../assets/patientFirstLogo.svg";
import { useGetShareId } from "../useStoredPatientCase";
import { useQueryParams } from "fe-common/useQueryParams";

//region [[ Styles ]]

const PatientFirstSummaryView = styled("div")(({ theme }) => ({
  position: "absolute",
  height: "100%",
  top: "0px",
  width: "100%",
  left: "0px",
}));

const BottomArea = styled("div")({
  position: "absolute",
  bottom: "0px",
  width: "100%",
  left: "0px",
  paddingLeft: PageMargin,
  paddingRight: PageMargin,
  paddingBottom: "20px",
});

const PopupTitleText = styled("div")(({ theme }) => ({
  fontSize: "18px",
  marginBottom: "10px",
  color: "white",
}));

const HeaderView = styled("div")(({ theme }) => ({
  marginTop: "58px",
  color: "white",
  fontSize: "16px",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  backgroundColor: KahunColorMap.PrimaryDim,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientFirstSummaryProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientFirstSummary = ({ ...props }: PatientFirstSummaryProps) => {
  const { navigateTo } = useRouteHelper();
  const { isMobile } = useScreenSize();
  const { setPatientFirstSummaryDialogProps } = useDiagnosticNavigation();
  const sharedId = useGetShareId();
  const queryParams = useQueryParams();
  const clinicId = queryParams.get("clinicId");

  useEffect(() => {
    if (!isMobile) {
      setPatientFirstSummaryDialogProps({ open: true });
      navigateTo({ route: AgentRoute.DD });
    } else {
      setPatientFirstSummaryDialogProps({ open: false });
    }
  }, [isMobile, navigateTo, setPatientFirstSummaryDialogProps]);

  const navigateToDD = () => {
    navigateTo({ route: AgentRoute.DD });
  };

  return (
    <PatientFirstSummaryView>
      <HeaderView>
        <PopupTitleText> Assessment of symptoms by</PopupTitleText>
        <PatientFirstLogo />
      </HeaderView>

      <PatientFirstSummaryContent sharedId={sharedId} clinicId={clinicId} />
      <BottomArea>
        <MainButton label={"See Kahun's Assessment"} onClick={navigateToDD} />
      </BottomArea>
    </PatientFirstSummaryView>
  );
};
